var _defs, _path, _g, _g2, _g3, _g4, _g5, _g6;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNyse(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 800,
    width: 1200,
    viewBox: "-14.795505 -24.764675 128.22771 148.58805",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(-90 2801.9699 2606.55) scale(1549.32)",
    spreadMethod: "pad",
    id: "b"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#b5e7f9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#a3e1f7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#8bdaf4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#6ed0f0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#55c7ee"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#4cb8e6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#439ed6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#3b8ac5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#3475b6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#3063a8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2b579e"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(-90 3012.2384 2396.2815) scale(1549.32)",
    spreadMethod: "pad",
    id: "d"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#b5e7f9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#a3e1f7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#8bdaf4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#6ed0f0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#55c7ee"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#4cb8e6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#439ed6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#3b8ac5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#3475b6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#3063a8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2b579e"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(-90 3221.4599 2187.06) scale(1549.32)",
    spreadMethod: "pad",
    id: "f"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#b5e7f9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#a3e1f7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#8bdaf4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#6ed0f0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#55c7ee"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#4cb8e6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#439ed6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#3b8ac5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#3475b6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#3063a8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2b579e"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(-90 3432.7649 1975.755) scale(1549.32)",
    spreadMethod: "pad",
    id: "h"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#b5e7f9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#a3e1f7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#8bdaf4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#6ed0f0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#55c7ee"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#4cb8e6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#439ed6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#3b8ac5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#3475b6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#3063a8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2b579e"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(-90 3640.2599 1768.26) scale(1549.32)",
    spreadMethod: "pad",
    id: "j"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#b5e7f9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#a3e1f7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#8bdaf4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#6ed0f0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#55c7ee"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#4cb8e6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#439ed6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#3b8ac5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#3475b6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#3063a8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2b579e"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(-90 3850.5199 1558) scale(1549.32)",
    spreadMethod: "pad",
    id: "l"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#b5e7f9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#a3e1f7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#8bdaf4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#6ed0f0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#55c7ee"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#4cb8e6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#439ed6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#3b8ac5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#3475b6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#3063a8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2b579e"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40.4922 3859.22h309.863v1549.32H40.4922z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "c"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M461.02 3859.22h309.875v1549.32H461.02z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "e"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M879.477 3859.22h309.863v1549.32H879.477z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "g"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1302.08 3859.22h309.863v1549.32H1302.08z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "i"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1717.08 3859.22h309.863v1549.32H1717.08z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "k"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2137.6 3859.22h309.867v1549.32H2137.6z"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.6688 98.7527H0v-28.604h5.669l11.564 18.1891V70.1486h5.669v28.604h-5.3003L5.6687 79.939v18.8137m21.315-28.6041h6.9145l6.3489 10.4715 6.378-10.4715h7.0313L43.083 86.4103v12.3424h-5.6691V86.267l-10.43-16.1185m44.2523 8.0707l2.9493-4.6296s-3.3796-3.6835-9.606-3.6835c-6.3166 0-9.234 4.2567-9.234 8.4706 0 4.2222 4.0685 7.0379 6.817 8.121 4.209 1.4844 7.1841 2.2143 7.1841 4.3342 0 1.6087-1.6297 2.8091-3.9225 2.8091-4.3004 0-7.7021-3.5115-7.7021-3.5115l-3.0776 4.8014s4.1053 4.1278 10.6797 4.1278c5.0917 0 9.6343-3.5521 9.6343-8.8004 0-4.7264-4.012-7.33-7.5153-8.3298-3.0365-.8858-6.2424-1.7347-6.2424-3.8817 0-1.4019 1.172-2.6942 3.221-2.6942 3.4747 0 6.8145 2.8666 6.8145 2.8666m8.8069 20.5335v-28.604h18.5936v4.9938H85.7122v6.811H96.823v4.9947H85.7122v6.8102h12.9245v4.9943H80.0431",
    fill: "#fff"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)",
    transform: "matrix(.04098 0 0 -.04103 -1.6593 221.8995)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40.4922 3859.22h309.863v1549.32H40.4922z",
    fill: "url(#b)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#c)",
    transform: "matrix(.04098 0 0 -.04103 -1.6593 221.8995)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M461.02 3859.22h309.875v1549.32H461.02z",
    fill: "url(#d)"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#e)",
    transform: "matrix(.04098 0 0 -.04103 -1.6593 221.8995)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M879.477 3859.22h309.863v1549.32H879.477z",
    fill: "url(#f)"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#g)",
    transform: "matrix(.04098 0 0 -.04103 -1.6593 221.8995)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1302.08 3859.22h309.863v1549.32H1302.08z",
    fill: "url(#h)"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#i)",
    transform: "matrix(.04098 0 0 -.04103 -1.6593 221.8995)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1717.08 3859.22h309.863v1549.32H1717.08z",
    fill: "url(#j)"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#k)",
    transform: "matrix(.04098 0 0 -.04103 -1.6593 221.8995)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2137.6 3859.22h309.867v1549.32H2137.6z",
    fill: "url(#l)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNyse);
export default __webpack_public_path__ + "static/media/nyse.1e0c85acabb3b4c18c6fd34d25356869.svg";
export { ForwardRef as ReactComponent };